import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import { Typography, Button } from '@material-ui/core';
import { css } from '@emotion/core';
import ErrorIcon from '@material-ui/icons/Error';
import { StandardBox, FlexDiv } from '../styles/styles';
import { COLORS } from '../util/Colors';

const BoxOverride = css`
  min-height: auto;
  height: 200px;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  #errorIcon {
    color: ${COLORS.red};
    font-size: 4rem;
  }
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { eventId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    const { hasError, eventId } = this.state;
    const { children } = this.props;
    if (hasError) {
      // return (
      //   <div
      //     style={{
      //       height: '100vh',
      //       width: '100vw',
      //       display: 'flex',
      //       justifyContent: 'center',
      //       alignItems: 'center',
      //     }}
      //   >
      //     <img
      //       src="https://i.ibb.co/HqCPYpk/Error-Message-1.png"
      //       height="200px"
      //     />
      //   </div>
      // );
      return (
        <FlexDiv style={{ height: '100vh' }}>
          <StandardBox css={BoxOverride}>
            <div>
              <ErrorIcon id="errorIcon" />
              <Typography variant="h5">
                DealMap has encountered an error
              </Typography>
            </div>
            <Button
              color="primary"
              style={{ background: COLORS.blue }}
              variant="contained"
              onClick={() => Sentry.showReportDialog({ eventId })}
            >
              Report feedback
            </Button>
          </StandardBox>
        </FlexDiv>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
